import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SkillSpecializationListItem } from '../../../models/skill-learning.model';

@Component({
  selector: 'app-skill-specialization-list',
  templateUrl: './specialization-list.component.html',
  styleUrls: ['./specialization-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkillSpecializationListComponent {

  @Input() specializations: SkillSpecializationListItem[] = [];
  @Input() canManage: boolean = false;

  @Output() editRequested = new EventEmitter<string>();
  @Output() deleteRequested = new EventEmitter<string>();
  @Output() createRequested = new EventEmitter<void>();

  trackBySpecializationId(index: number, item: SkillSpecializationListItem): string {
    return item.id;
  }

  onEditClick(id: string): void {
    this.editRequested.emit(id);
  }

  onDeleteClick(id: string): void {
    this.deleteRequested.emit(id);
  }

  onCreateClick(): void {
    this.createRequested.emit();
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/specialization-list/specialization-list.component.ts